import common from './common';
import sales from './sales';

export default {
	app_name: 'TumTum',
	...common,
	...sales
};
